export { GalleryControlComponent } from './lib/gallery-control.component';
export { GALLERY_IMAGE_CONFIG_INJECTION_TOKEN } from './lib/config-injection-token/gallery-image-config-injection-token';
